import { useMemo } from "react";
import { INSIGHTS_SERIES_COLORS, typesColors } from "../consts/configs";
import { formatMonth } from "@/core/utils";
import { useTranslation } from "react-i18next";
import { productTypeNames } from "@/core/utils";

export function useReportTransforms(reportData: any) {
  const [translate] = useTranslation(["insights"]);
  return useMemo(() => {
    const spaceDistributionData = (reportData?.distribution_by_type ?? []).map(
      (item: any) => {
        const total = (reportData?.distribution_by_type ?? []).reduce(
          (sum: number, t: any) => sum + t.reservations,
          0,
        );

        return {
          name: translate(productTypeNames[item.type]),
          value: item.reservations,
          percentage: total ? Math.round((item.reservations / total) * 100) : 0,
          color: typesColors[item.type] || INSIGHTS_SERIES_COLORS.gray500,
        };
      },
    );

    const creditConsumptionData = (
      reportData?.evolution_reservations ?? []
    ).map((it: any) => {
      const { m } = formatMonth(it.month);
      return { month: m, value: Math.round(it.credits) };
    });

    const spaceRankingData = (reportData?.ranking_spaces ?? [])
      .slice(0, 5)
      .map((space: any, index: number) => ({
        name: space.space_name,
        location: space.cityname,
        reservations: space.reservations,
        position: index + 1,
      }));

    const reservationEvolutionData = (
      reportData?.evolution_reservations ?? []
    ).map((it: any) => {
      const { m } = formatMonth(it.month);
      return { month: m, reservations: it.reservations };
    });

    const cancellationData = [
      {
        name: translate("report-export-insights-confirmed"),
        value:
          reportData?.status_and_checkin?.status_reservations?.confirmed
            ?.percent ?? 0,
        color: INSIGHTS_SERIES_COLORS.green600,
      },
      {
        name: translate("report-export-insights-canceled"),
        value:
          reportData?.status_and_checkin?.status_reservations?.canceled
            ?.percent ?? 0,
        color: INSIGHTS_SERIES_COLORS.red600,
      },
    ];

    const checkinData = [
      {
        name: translate("report-export-insights-with-checkin"),
        value:
          reportData?.status_and_checkin?.checkins?.checkin_true?.percent ?? 0,
        color: INSIGHTS_SERIES_COLORS.blue600,
      },
      {
        name: translate("report-export-insights-without-checkin"),
        value:
          reportData?.status_and_checkin?.checkins?.checkin_false?.percent ?? 0,
        color: INSIGHTS_SERIES_COLORS.slate400,
      },
    ];

    return {
      spaceDistributionData,
      creditConsumptionData,
      spaceRankingData,
      reservationEvolutionData,
      cancellationData,
      checkinData,
    } as const;
  }, [reportData]);
}
